import cx from 'clsx';

import styles from 'theme/components/spacing-layout.module.scss';

const SpacingLayout = ({ children, className }) => <div className={cx(styles.wrapper, className)}>{children}</div>;

export default SpacingLayout;
